/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Nutrition_UnverifiedInputs */

const en_nutrition_unverified = /** @type {(inputs: Nutrition_UnverifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unchecked catalog values: ${i?.names}.`)
};

const de_nutrition_unverified = /** @type {(inputs: Nutrition_UnverifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ungeprüfte Katalogwerte: ${i?.names}.`)
};

/**
* | output |
* | --- |
* | "Unchecked catalog values: {names}." |
*
* @param {Nutrition_UnverifiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_unverified = /** @type {((inputs: Nutrition_UnverifiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_UnverifiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_unverified(inputs)
	return en_nutrition_unverified(inputs)
});